export const usePermissionsStore = defineStore("permissions", () => {
  const permissions = ref(null);
  function check(key, permission) {
    const securityStore = useSecurityStore();
    const permissions = securityStore.permissions ? securityStore.permissions : ["Меню"];
    const actualPermissions = permissions.filter(x => x.targetType === key) || [];
    if (actualPermissions == null || actualPermissions.length === 0) {
      return false;
    }
    switch (permission) {
      case "create":
        return actualPermissions.some(x => x.allowCreate);
      case "delete":
        return actualPermissions.some(x => x.allowDelete);
      case "edit":
        return actualPermissions.some(x => x.allowWrite);
      case "read":
        return actualPermissions.some(x => x.allowRead);
      case "navigate":
        return actualPermissions.some(x => x.allowNavigate);
    }
  }
  function allowEditMdpDepartments(allowedEmployeeIds, documentStatus) {
    const securityStore = useSecurityStore();
    if (documentStatus !== "МДП") return false;
    return allowedEmployeeIds.includes(securityStore.oid);
  }
  return {
    permissions,
    check,
    allowEditMdpDepartments
  };
}, {
  persist: true
});